import { render, staticRenderFns } from "./Demands.vue?vue&type=template&id=cbae7f88&scoped=true&"
import script from "./Demands.vue?vue&type=script&lang=js&"
export * from "./Demands.vue?vue&type=script&lang=js&"
import style0 from "./Demands.vue?vue&type=style&index=0&id=cbae7f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbae7f88",
  null
  
)

export default component.exports